import { component as defineComponent } from 'flightjs';

function ButtonSpinner() {
    this.attributes({
        startOn: 'spinnerStart',
        endOn: 'spinnerStop',
        listenOn: document,
        autoStart: false,
        spinnerMarkup: '<span class="button__icon"><span class="spinner"></span></span>',
        buttonClass: 'button--icon-right',
    });

    this.spinnerStart = function(event, data) {
        var buttonInner = this.$node.find('.button__inner');
        var spinner = this.$node.find('.spinner');

        if (buttonInner.length > 0 && spinner.length === 0) {
            if (!this.$node.hasClass(this.attr.buttonClass)) {
                this.$node.addClass(this.attr.buttonClass);
            }
            buttonInner.append(this.attr.spinnerMarkup);
        }

        this.$node.attr('disabled', true);
        this.$node.attr('data-spinning', true);
    };

    this.spinnerStop = function(event, data) {
        var spinner = this.$node.find('.spinner');

        if (spinner.length > 0) {
            var buttonIcon = spinner.parent('.button__icon');

            if (buttonIcon.length > 0) {
                buttonIcon.remove();
            }

            this.$node.removeClass(this.attr.buttonClass);
        }

        this.$node.attr('disabled', false);
        this.$node.removeAttr('data-spinning');
    };

    this.after('initialize', function() {
        if (this.attr.autoStart === true) {
            this.spinnerStart();
        }

        this.on(this.attr.listenOn, this.attr.startOn, this.spinnerStart);
        this.on(this.attr.listenOn, this.attr.endOn, this.spinnerStop);
    });
}

export default defineComponent(ButtonSpinner);



// WEBPACK FOOTER //
// ./src/web/js/app/modules/button-spinner.js